import {isNaN, isNumber} from 'lodash-es'
import moment from 'moment'
import {airfareMaxChildAge} from 'root-config/constants.js'

const isAirfareChild = age => age <= airfareMaxChildAge

export const passengerQualifiesForChildFare = (passenger, dateToCompare) => {
  const isChild = passenger.type === 'child'
  const birthday = moment(new Date(passenger.dateOfBirth), 'YYYY-MM-DD')
  const age = birthday.isValid() ? moment(dateToCompare).diff(birthday, 'years') : passenger.age
  const isValidAge = isNumber(age) && !isNaN(age)
  return isChild && isValidAge && isAirfareChild(age)
}

export const calculateAirfareParty = (passengers, dateToCompare) => {
  return passengers.reduce((party, passenger) => {
    if (passengerQualifiesForChildFare(passenger, dateToCompare)) {
      party.children += 1
    } else {
      party.adults += 1
    }
    return party
  }, {
    adults: 0,
    children: 0,
  })
}
